if (!customElements.get('gift-box-offer')) {
  customElements.define(
    'gift-box-offer',
    class GiftBoxOffer extends HTMLElement {
      connectedCallback() {
        this.variantId = this.dataset.variantId;
        this.checkInput = this.querySelector('input[type="checkbox"]');
        if (!this.variantId || !this.checkInput || this.bound) return;

        this.bound = true;
        this.checkInput.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const adding = this.checkInput.checked;
        const cartItems = document.getElementById(`Cart-Items-Main-${this.dataset.section}`);

        if (!cartItems) {
          window.location.reload();
          return;
        }

        const body = JSON.stringify({
          updates: { [this.variantId]: adding ? 1 : 0 },
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        cartItems.enableLoading();
        this.checkInput.setAttribute('disabled', 'true');

        fetch(window['routes']['cart_update_url'], { ...webvista.fetchConfig(), body })
          .then((response) => response.json())
          .then((responseJson) => {
            if (!responseJson.items) throw new Error('Cart update failed');
            cartItems.handleCartUpdate(responseJson, this.variantId, this.checkInput);
          })
          .catch(() => {
            this.checkInput.checked = !adding;
            webvista.popToast(window['accessibilityStrings']['unknownError'], 'error');
          })
          .finally(() => {
            cartItems.disableLoading();
            this.checkInput.removeAttribute('disabled');
          });
      }
    }
  );
}